import { util, z, ZodIssueCode, ZodParsedType } from "zod"
import type { ZodErrorMap } from "zod"

export default defineNuxtPlugin((nuxtApp) => {
  const errorMap = (issue: any, _ctx: any) => {
    let message
    switch (issue.code) {
      case ZodIssueCode.invalid_type:
        if (issue.received === ZodParsedType.undefined) {
          message = "Zorunlu alan"
        } else {
          message = `Beklenen: ${issue.expected}, alınan: ${issue.received}`
        }
        break
      case ZodIssueCode.invalid_literal:
        message = `Geçersiz değer, beklenen: ${JSON.stringify(issue.expected, util.jsonStringifyReplacer)}`
        break
      case ZodIssueCode.unrecognized_keys:
        message = `Nesnede tanınmayan anahtar(lar): ${util.joinValues(issue.keys, ", ")}`
        break
      case ZodIssueCode.invalid_union:
        message = `Geçersiz girdi`
        break
      case ZodIssueCode.invalid_union_discriminator:
        message = `Geçersiz ayırıcı değeri. Beklenen: ${util.joinValues(issue.options)}`
        break
      case ZodIssueCode.invalid_enum_value:
        message = `Geçersiz enum değeri. Beklenen: ${util.joinValues(issue.options)}, alınan: '${issue.received}'`
        break
      case ZodIssueCode.invalid_arguments:
        message = `Geçersiz fonksiyon parametreleri`
        break
      case ZodIssueCode.invalid_return_type:
        message = `Geçersiz fonksiyon dönüş tipi`
        break
      case ZodIssueCode.invalid_date:
        message = `Geçersiz tarih`
        break
      case ZodIssueCode.invalid_string:
        if (typeof issue.validation === "object") {
          if ("includes" in issue.validation) {
            message = `Geçersiz girdi: "${issue.validation.includes}" içermeli`
            if (typeof issue.validation.position === "number") {
              message = `${message}, ${issue.validation.position} veya daha büyük bir pozisyonda`
            }
          } else if ("startsWith" in issue.validation) {
            message = `Geçersiz girdi: "${issue.validation.startsWith}" ile başlamalı`
          } else if ("endsWith" in issue.validation) {
            message = `Geçersiz girdi: "${issue.validation.endsWith}" ile bitmeli`
          } else {
            // util.assertNever(issue.validation)
          }
        } else if (issue.validation !== "regex") {
          message = `Geçersiz ${issue.validation}`
        } else {
          message = "Geçersiz"
        }
        break
      case ZodIssueCode.too_small:
        if (issue.type === "array")
          message = `Dizi ${issue.exact ? "tam olarak" : issue.inclusive ? `en az` : `daha fazla`} ${issue.minimum} eleman içermeli`
        else if (issue.type === "string")
          message = `Metin ${issue.exact ? "tam olarak" : issue.inclusive ? `en az` : `daha fazla`} ${issue.minimum} karakter içermeli`
        else if (issue.type === "number")
          message = `Sayı ${issue.exact ? `tam olarak ` : issue.inclusive ? `büyük veya eşit olmalı: ` : `büyük olmalı: `}${issue.minimum}`
        else if (issue.type === "date")
          message = `Tarih ${issue.exact ? `tam olarak ` : issue.inclusive ? `büyük veya eşit olmalı: ` : `büyük olmalı: `}${new Date(Number(issue.minimum))}`
        else message = "Geçersiz girdi"
        break
      case ZodIssueCode.too_big:
        if (issue.type === "array")
          message = `Dizi ${issue.exact ? `tam olarak` : issue.inclusive ? `en fazla` : `daha az`} ${issue.maximum} eleman içermeli`
        else if (issue.type === "string")
          message = `Metin ${issue.exact ? `tam olarak` : issue.inclusive ? `en fazla` : `daha az`} ${issue.maximum} karakter içermeli`
        else if (issue.type === "number")
          message = `Sayı ${issue.exact ? `tam olarak` : issue.inclusive ? `küçük veya eşit olmalı: ` : `küçük olmalı: `} ${issue.maximum}`
        else if (issue.type === "bigint")
          message = `BigInt ${issue.exact ? `tam olarak` : issue.inclusive ? `küçük veya eşit olmalı: ` : `küçük olmalı: `} ${issue.maximum}`
        else if (issue.type === "date")
          message = `Tarih ${issue.exact ? `tam olarak` : issue.inclusive ? `küçük veya eşit olmalı: ` : `küçük olmalı: `} ${new Date(Number(issue.maximum))}`
        else message = "Geçersiz girdi"
        break
      case ZodIssueCode.custom:
        message = `Geçersiz girdi`
        break
      case ZodIssueCode.invalid_intersection_types:
        message = `Kesişim sonuçları birleştirilemedi`
        break
      case ZodIssueCode.not_multiple_of:
        message = `Sayı ${issue.multipleOf}'nin katı olmalı`
        break
      case ZodIssueCode.not_finite:
        message = "Sayı sonlu olmalı"
        break
      default:
        message = _ctx.defaultError
      // util.assertNever(issue)
    }
    return { message }
  }

  z.setErrorMap(errorMap as ZodErrorMap)
})
